// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_640f1808","link":"rdg_749753d7"};